import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/navigation", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/navigation/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/navigation", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/navigation/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/navigation/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/navigation`);
};

const findByTitle = (title) => {
  return instance.get(`/navigation?title=${title}`);
};

const NavigationService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default NavigationService;
